"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { api, errorMessage } from "@/lib/api-client";
import { Button } from "@/components/ui/button";
import { Field, Input } from "@/components/ui/field";
import { Alert } from "@/components/ui/alert";

export function LoginForm({ next, showDemo }: { next: string; showDemo: boolean }) {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await api.post("/auth/login", { email, password });
      router.push(next);
      router.refresh();
    } catch (err) {
      setError(errorMessage(err));
      setLoading(false);
    }
  }

  return (
    <form onSubmit={submit} className="mt-8 space-y-4">
      {error ? <Alert tone="critical">{error}</Alert> : null}
      <Field label="Email" htmlFor="email">
        <Input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
      </Field>
      <Field label="Password" htmlFor="password">
        <Input id="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
      </Field>
      <Button type="submit" className="w-full" loading={loading}>
        Sign in
      </Button>
      {showDemo ? (
        <div className="rounded-lg bg-slate-50 p-3 text-xs text-ink-soft ring-1 ring-line">
          <p className="font-medium text-ink">Demo workspace</p>
          <p className="mt-0.5">
            demo@erlen.dev / erlen-demo{" "}
            <button
              type="button"
              className="ml-1 font-medium text-brand-700 hover:underline"
              onClick={() => {
                setEmail("demo@erlen.dev");
                setPassword("erlen-demo");
              }}
            >
              Fill in
            </button>
          </p>
        </div>
      ) : null}
    </form>
  );
}
